module.exports = __webpack_public_path__ + "static/media/EG.18f5e988.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/EG.svg
// module id = 2145
// module chunks = 7